import HeaderSection from '../../../../../components/Header/HeaderSection'
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function PathoRiskText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Important" 
            headline_grey = "Genetic Variants"
            headline_p2 = "you should know"

            text1 = "Your personal watchlist contains genetic variants that have been identified during your genetic sequencing. This section lists each variant and indicates whether it’s linked to a Mendelian disorder or a common complex condition."
            text2 = "Pathogenic and likely pathogenic variants are strong indicators of disease risk and often have medical implications. Risk and likely risk variants suggest increased susceptibility but don’t guarantee a disease outcome."
            text3 = "This information can guide your decisions regarding health monitoring or lifestyle adjustments. The 'Important Read' tab explains all key terms and classifications."

            />
    }/>
            
  )
}